import { render, staticRenderFns } from "./WebChatRoute.vue?vue&type=template&id=63d85655"
import script from "./WebChatRoute.vue?vue&type=script&lang=ts"
export * from "./WebChatRoute.vue?vue&type=script&lang=ts"
import style0 from "./WebChatRoute.vue?vue&type=style&index=0&id=63d85655&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports